import { Chip } from '@mui/material';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const levelColor = {
  info: { bg: 'rgba(59,130,246,0.12)', color: '#1d4ed8' },
  success: { bg: 'rgba(22,163,74,0.12)', color: '#166534' },
  warning: { bg: 'rgba(245,158,11,0.16)', color: '#92400e' },
  critical: { bg: 'rgba(220,38,38,0.14)', color: '#991b1b' }
};

const audienceLabel = {
  all: 'All Users',
  users: 'Users',
  admins: 'Admins'
};

const AdminAnnouncementsPage = () => {
  const columns = [
    { key: 'title', label: 'Title' },
    {
      key: 'level',
      label: 'Level',
      render: (row) => {
        const palette = levelColor[row.level] || levelColor.info;
        return (
          <Chip
            size="small"
            label={row.level || 'info'}
            sx={{ bgcolor: palette.bg, color: palette.color, fontWeight: 600, textTransform: 'capitalize' }}
          />
        );
      }
    },
    {
      key: 'audience',
      label: 'Audience',
      render: (row) => <Chip size="small" label={audienceLabel[row.audience] || row.audience || 'All Users'} />
    },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    },
    {
      key: 'created_at',
      label: 'Created',
      render: (row) => (row.created_at ? new Date(row.created_at).toLocaleString() : '-')
    }
  ];

  const fields = [
    { name: 'title', label: 'Title', type: 'text', grid: 6 },
    { name: 'summary', label: 'Summary', type: 'text', grid: 6 },
    {
      name: 'level',
      label: 'Level',
      type: 'select',
      grid: 4,
      defaultValue: 'info',
      options: [
        { value: 'info', label: 'Info' },
        { value: 'success', label: 'Success' },
        { value: 'warning', label: 'Warning' },
        { value: 'critical', label: 'Critical' }
      ]
    },
    {
      name: 'audience',
      label: 'Audience',
      type: 'select',
      grid: 4,
      defaultValue: 'all',
      options: [
        { value: 'all', label: 'All Users' },
        { value: 'users', label: 'Users only' },
        { value: 'admins', label: 'Admins only' }
      ]
    },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 4, defaultValue: true },
    {
      name: 'starts_at',
      label: 'Starts At (ISO datetime)',
      type: 'text',
      grid: 6,
      nullable: true,
      defaultValue: ''
    },
    {
      name: 'ends_at',
      label: 'Ends At (ISO datetime)',
      type: 'text',
      grid: 6,
      nullable: true,
      defaultValue: ''
    },
    { name: 'body', label: 'Message Body', type: 'multiline', grid: 12 }
  ];

  return (
    <AdminResourceCrudPage
      title="Announcements"
      subtitle="Publish security advisories and platform broadcast messages for users and administrators."
      icon={CampaignOutlinedIcon}
      endpoint="/api/admin/announcements/"
      columns={columns}
      fields={fields}
    />
  );
};

export default AdminAnnouncementsPage;
